import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { AcquireRouteWizardCtrlDto } from '@shared/src/dtos/route/acquire/AcquireRouteWizardCtrlDto';
import { RouteAcquireRouteSearchDto } from '@shared/src/dtos/route/acquire/RouteAcquireRouteSearchDto';
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SharedRouteAcquireWizard } from '../shared.route.acquire.wizard';

@Component({
	selector: 'shared-route-acquire-wizard-selectroute',
	templateUrl: './shared.route.acquire.wizard.selectroute.html',
	styleUrls: ['./shared.route.acquire.wizard.selectroute.scss']
})
export class SharedRouteAcquireWizardSelectRoute implements OnInit {

	searchTextUpdate = new Subject<string>();

	public useIonic: boolean = false;
	constructor(public routeController: RouteController,
		@Inject('HomeController') protected homeController: HomeController) {

		// Debounce search.
		this.searchTextUpdate.pipe(
			debounceTime(HomeController.DEFAULT_BOUNCE_BUTTON_TIME),
			distinctUntilChanged())
			.subscribe(value => {
				//Refresquem si treiem el searchText
				this.loadData(false);
			});


		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}

	public searchText: string = "";

	public routesCount: number = 0;

	public sliceCount: number = SharedRouteAcquireWizard.SLICECOUNTINITIAL;



	ngOnInit(): void {
		this.loadActions();
	}

	public _wizard: AcquireRouteWizardCtrlDto;
	@Input()
	public get wizard(): AcquireRouteWizardCtrlDto {
		return this._wizard;
	}
	public set wizard(value: AcquireRouteWizardCtrlDto) {
		if (this._wizard === value)
			return;
		this._wizard = value;
	}


	public hiddenRoutesMessage: string;
	public routes: Array<RouteCardItemDto> = [];

	public filter: RouteAcquireRouteSearchDto = new RouteAcquireRouteSearchDto();
	loadData(busy: boolean) {

		//Si tenim ruta seleccionada, no te sentit fer cerca total
		if (this.wizard == null || this.wizard.selectedPartner == null)
			return;

		this.hiddenRoutesMessage = "";
		this.routes = [];
		this.wizard.selectedRoutesIds = [];
		this.filter.partner = this.wizard.selectedPartner;
		this.filter.searchText = this.searchText;

		this.routeController.wizardAcquireRoutesSearch(this.filter, false).subscribe(e => {
			if (e) {
				this.routes = e.routes;
				this.hiddenRoutesMessage = e.hiddenRoutesMessage;
			}
		});

	}

	getSelectedRoutesCount(): number {
		let x = this.getSelectedRoutes();
		if (x)
			return x.length;
		return 0;
	}
	getRoutes() {
		if (this.routes != null && this.routes.length > 0)
			return this.routes;
		return [];
	}
	isEmpty(): boolean {
		if (this.routes != null && this.routes.length > 0)
			return false;
		return true;
	}
	getSelectedRoutes() {
		if (this.routes != null && this.routes.length > 0)
			return this.routes.filter(r => this.wizard.selectedRoutesIds.includes(r.routeId));
		return [];
	}

	@Output() selectRoutes = new EventEmitter<AcquireRouteWizardCtrlDto>();
	onSelectRoute(item: RouteCardItemDto) {
		if (this.wizard.selectedRoutesIds.includes(item.routeId))
			this.wizard.selectedRoutesIds.splice(this.wizard.selectedRoutesIds.indexOf(item.routeId), 1);
		else
			this.wizard.selectedRoutesIds.push(item.routeId);

		this.wizard.calculateInternalData();
		this.selectRoutes.next(this.wizard);
	}

	public actions: ActionsStripDto;
	public loadActions() {
		this.actions = new ActionsStripDto();
		this.actions.add(ActionDto.buildAdd("SELECTALL", "SHARED.ROUTE.ACQUIRE.WIZARD.SELECTROUTE.SELECTALL.CAPTION", null, null, 0, -1, 1, null));
		this.actions.add(ActionDto.build("DESELECTALL", "SHARED.ROUTE.ACQUIRE.WIZARD.SELECTROUTE.DESELECTALL.CAPTION", null, null, 1, -1, 1, null));
	}

	public onClickAction(item: ActionDto) {
		if (!item)
			return;

		switch (item.actionId) {
			case "SELECTALL":
				this.wizard.selectedRoutesIds = [];
				this.wizard.selectedRoutesIds = this.getRoutes().map((r: RouteCardItemDto) => r.routeId);
				this.wizard.calculateInternalData();
				this.selectRoutes.next(this.wizard);
				break;
			case "DESELECTALL":
				this.wizard.selectedRoutesIds = [];
				this.wizard.calculateInternalData();
				this.selectRoutes.next(this.wizard);
				break;
			default:
				break;
		}

	}
	public isSelected(routeId: number) {
		if (this.wizard != null && this.wizard.selectedRoutesIds != null)
			return this.wizard.selectedRoutesIds.includes(routeId)
		return false;
	}

	pretty(value) {
		return JSON.stringify(value);
	}
}
